import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d057959")

_pushScopeId("data-v-1d057959")
const _hoisted_1 = { class: "filter-container" }
const _hoisted_2 = { class: "datepicker" }
const _hoisted_3 = {
  key: 0,
  class: "text-red-lp-300 text-12px absolute font-normal"
}
const _hoisted_4 = { class: "responsive-mobile " }
const _hoisted_5 = {
  key: 0,
  class: "text-red-lp-300 text-12px absolute font-normal"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_advance_filter = _resolveComponent("advance-filter")!
  const _component_DatePickerBottomSheet = _resolveComponent("DatePickerBottomSheet")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_TimeRangePicker, _mergeProps({
        startDate: _ctx.filterClientDashboard.startDate,
        endDate: _ctx.filterClientDashboard.endDate,
        onSelect: _ctx.setDateRange
      }, _ctx.timeRangePickerAttributes), null, 16, ["startDate", "endDate", "onSelect"]),
      (_ctx.isErrorTimeRange)
        ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("dashboard.filterLabels.maxDaysError")), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_CustomDropdown, {
      class: "product-filter",
      options: _ctx.optionProduct,
      onSelect: _ctx.selectProduct,
      placeholder: _ctx.$t('dashboard.filterLabels.selectService'),
      isCustomWidth: "",
      selectedItem: _ctx.filterClientDashboard.product
    }, null, 8, ["options", "onSelect", "placeholder", "selectedItem"]),
    _createVNode(_component_CustomDropdown, {
      class: "delivery-filter",
      options: _ctx.optionDeliveryType,
      onSelect: _ctx.selectDeliveryType,
      placeholder: _ctx.$t('dashboard.filterLabels.selectDelivery'),
      isCustomWidth: "",
      selectedItem: _ctx.filterClientDashboard.deliveryType
    }, null, 8, ["options", "onSelect", "placeholder", "selectedItem"]),
    _createVNode(_component_advance_filter, {
      class: "responsive-mobile",
      optionDeliveryType: _ctx.optionDeliveryType,
      optionProduct: _ctx.optionProduct,
      labelProduct: _ctx.labelProduct,
      onChange: _ctx.onChangeAdvancedFilter
    }, null, 8, ["optionDeliveryType", "optionProduct", "labelProduct", "onChange"]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_DatePickerBottomSheet, {
        type: "range-1",
        placeholder: _ctx.$t('dashboard.filterLabels.selectDate'),
        modelValue: {
          start: _ctx.filterClientDashboard.startDate,
          end: _ctx.filterClientDashboard.endDate
        },
        maxDate: new Date(),
        onChange: _cache[1] || (_cache[1] = (e) => _ctx.setDateRange([e.start, e.end]))
      }, null, 8, ["placeholder", "modelValue", "maxDate"]),
      (_ctx.isErrorTimeRange)
        ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("dashboard.filterLabels.maxDaysError")), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isClientParent)
      ? (_openBlock(), _createBlock(_component_CustomDropdown, {
          key: 0,
          class: "w-56",
          options: _ctx.mappedDataClient,
          onSelect: _ctx.selectBranch,
          placeholder: _ctx.$t('dashboard.filterLabels.selectDelivery'),
          isCustomWidth: "",
          selectedItem: _ctx.filterClientDashboard.branch
        }, null, 8, ["options", "onSelect", "placeholder", "selectedItem"]))
      : _createCommentVNode("", true)
  ]))
})